export const GET_GROUPS_SUCCESS = 'GET_GROUPS_SUCCESS';
export const GET_PPRODUCTS = 'GET_PPRODUCTS';
export const SET_CAT_PRODUCT_FILTER = 'SET_CAT_PRODUCT_FILTER';
export const SET_PPRODUCT_DATA = 'SET_PPRODUCT_DATA';
